/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AdminFamilyBalancesGetFamilyBalancesParams,
  AdminOrganizationFamilyBalanceDTOQueryResultDTO,
  FilterModelDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminFamilyBalancesGetFamilyBalances = (
    organizationId: number,
    semesterId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminFamilyBalancesGetFamilyBalancesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminOrganizationFamilyBalanceDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminFamilyBalances/list/${semesterId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminFamilyBalancesGetFamilyBalancesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFamilyBalancesGetFamilyBalancesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFamilyBalancesGetFamilyBalancesParams}, TContext> => {
    
const mutationKey = ['adminFamilyBalancesGetFamilyBalances'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>, {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFamilyBalancesGetFamilyBalancesParams}> = (props) => {
          const {organizationId,semesterId,data,params} = props ?? {};

          return  adminFamilyBalancesGetFamilyBalances(organizationId,semesterId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminFamilyBalancesGetFamilyBalancesMutationResult = NonNullable<Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>>
    export type AdminFamilyBalancesGetFamilyBalancesMutationBody = FilterModelDTO[]
    export type AdminFamilyBalancesGetFamilyBalancesMutationError = ErrorType<unknown>

    export const useAdminFamilyBalancesGetFamilyBalances = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFamilyBalancesGetFamilyBalancesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFamilyBalancesGetFamilyBalances>>,
        TError,
        {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFamilyBalancesGetFamilyBalancesParams},
        TContext
      > => {

      const mutationOptions = getAdminFamilyBalancesGetFamilyBalancesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    